module.exports = __webpack_public_path__ + "static/media/product2.13318fbb.png";